import store from 'store'
import { toast } from 'react-toastify'

import { _object } from 'utils/interfaces'

export default class CommonService {
  baseURL: string
  defaultHeaders: { [key: string]: string }
  constructor() {
    this.baseURL = process.env.REACT_APP_BASE_URL || ''

    this.defaultHeaders = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: store.get(process.env.REACT_APP_ACCESS_TOKEN_KEY || '') || null
    }
  }

  async request(endpoint: string, options: _object, toastify: boolean) {
    const url = `${this.baseURL}${endpoint}`
    const response = await fetch(url, options)
    const data = await response.json()

    if (response.status === 401 || response.status === 403) {
      toast.error(data.message + '.', { autoClose: 3000 })
      store.clearAll()
      window.location.replace('/login')
    } else if (data.error === false) {
      toastify === true && toast.success(data.message + '.', { autoClose: 3000 })
    } else if (data.error === true) {
      toastify === true && toast.error(data.message + '.', { autoClose: 3000 })
    }
    return data
  }

  async get(endpoint: string, toastify = false) {
    const options = {
      method: 'GET',
      headers: this.defaultHeaders
    }
    return await this.request(endpoint, options, toastify)
  }

  async post(endpoint: string, params = {}, toastify = true) {
    const options = {
      method: 'POST',
      headers: this.defaultHeaders,
      body: JSON.stringify(params)
    }
    return await this.request(endpoint, options, toastify)
  }

  async put(endpoint: string, params = {}, toastify = true) {
    const options = {
      method: 'PUT',
      headers: this.defaultHeaders,
      body: JSON.stringify(params)
    }
    return await this.request(endpoint, options, toastify)
  }

  async delete(endpoint: string, toastify = true) {
    const options = {
      method: 'DELETE',
      headers: this.defaultHeaders
    }
    return await this.request(endpoint, options, toastify)
  }
}
